function resolveModeController(args) {
    const { modeKey, modeControllers, fallbackController } = args;
    if (typeof modeKey === 'string' && Object.prototype.hasOwnProperty.call(modeControllers, modeKey)) {
        return modeControllers[modeKey] ?? fallbackController;
    }
    return fallbackController;
}
export function createModeAwareDescriptor(args) {
    const { baseDescriptor, modePolicy, fallbackController } = args;
    return {
        baseDescriptor,
        runtime: {
            kind: 'mode-aware',
            policy: modePolicy,
            fallbackController,
        },
    };
}
export function resolveRuntimeController(args) {
    if (args.descriptor.runtime.kind === 'single') {
        return args.descriptor.runtime.controller;
    }
    const { policy, fallbackController } = args.descriptor.runtime;
    const runtimeState = args.runtimeState;
    const modeKey = policy.resolveModeKey({
        config: args.config,
        ...(runtimeState === undefined ? {} : { runtimeState }),
    });
    return resolveModeController({
        modeKey,
        modeControllers: policy.modeControllers,
        fallbackController,
    });
}
